module.exports = __webpack_public_path__ + "img/5.d013be7f.png";